<template>
    <tr class="tw-text-xs tw-bg-primary-50">
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold">
            Summary
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold">
            {{ formatNumber(props.summary.total_orders, {}) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold">
            <div class="tw-flex tw-flex-col tw-items-center">
                <div class="tw-font-bold">
                    {{ formatNumber(props.summary.total_confirmed_orders, {}) }}
                </div>
                <div class="tw-text-xs tw-text-gray-500 tw-mt-0.5">
                    {{ formatNumber(calculateConfirmationRate(props.summary), { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }) }}
                </div>
            </div>
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold">
            <div class="tw-flex tw-flex-col tw-items-center">
                <div class="tw-font-bold">
                    {{ formatNumber(props.summary.total_delivered_orders, {}) }}
                </div>
                <div class="tw-text-xs tw-text-gray-500 tw-mt-0.5">
                    {{ formatNumber(calculateDeliveryRate(props.summary), { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }) }}
                </div>
            </div>
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold">
            {{ formatNumber(props.summary.total_delivered_quantity, {}) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-sky-500">
            {{ formatNumber(getValueInUSD(props.summary.total_turnover)) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-gray-500">
            {{ formatNumber(props.summary.total_delivered_product_cost) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-purple-500">
            {{ formatNumber(getValueInUSD(props.summary.shipping_cost)) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-amber-500">
            {{ formatNumber(props.summary.total_spend) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-pink-500">
            {{ formatNumber(props.summary.total_delivered_orders * 1) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-gray-500">
            {{ formatNumber(calculateCostPerOrder(props.summary)) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-emerald-500" 
            :class="[(props.summary.profit_per_order) <= 0 && '!tw-text-rose-500 tw-bg-rose-100']">
            {{ formatNumber(props.summary.profit_per_order) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-emerald-500"
            :class="[props.summary.profit_per_unit <= 0 && '!tw-text-rose-500 tw-bg-rose-100']">
            {{ formatNumber(props.summary.profit_per_unit) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold tw-text-emerald-500"
            :class="[props.summary.total_profit <= 0 && '!tw-text-rose-500 tw-bg-rose-100']">
            {{ formatNumber(props.summary.total_profit) }}
        </td>
        <td class="tw-px-2 tw-py-0.5 tw-text-center tw-font-bold">
            <!-- Actions column - empty for summary -->
        </td>
    </tr>
</template>

<script setup>
import { defineProps, inject, ref } from 'vue';

const props = defineProps({
    summary: {
        type: Object,
        default: () => ({})
    }
})

const exchange = inject('exchange', ref(4.88));

const formatNumber = (number, type = {style: 'currency', currency: 'USD'}) => {
    return new Intl.NumberFormat('en', { maximumFractionDigits: 2, ...type }).format(number);
}

const getValueInUSD = (number) => {
    if(!number) return 0;
    return (number / exchange.value);
}

const calculateCostPerOrder = (item) => {
    if (!item.total_orders || item.total_orders === 0) return 0;
    const totalCost = item.total_spend;
    return totalCost / item.total_orders;
}

const calculateConfirmationRate = (item) => {
    if (!item.total_orders) return 0;
    return item.total_confirmed_orders / (item.total_orders - (item.total_duplicated_orders || 0));
}

const calculateDeliveryRate = (item) => {
    if (!item.total_confirmed_orders) return 0;
    return item.total_delivered_orders / (item.total_confirmed_orders);
}

console.log('Summary:', props.summary);
</script>